import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"
import _imports_0 from '../assets/sounds/siren.mp3'


const _hoisted_1 = { ref: "audio" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("source", { src: _imports_0 }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Notifications = _resolveComponent("Notifications")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeAlarms, (alarm, index) => {
      return (_openBlock(), _createBlock(_component_Notifications, {
        alarm: alarm,
        index: index,
        key: alarm.id,
        onOnRemoveAlarm: _ctx.ackAlarm
      }, null, 8, ["alarm", "index", "onOnRemoveAlarm"]))
    }), 128)),
    _createVNode(_component_router_view),
    _createElementVNode("audio", _hoisted_1, _hoisted_3, 512)
  ], 64))
}